import { Button, Text } from '@shared/components';
import { PageContentPermissionChoice } from './usePageContentPermission';

type PageContentPermissionPromptProps = {
  hostname: string;
  onRespond: (choice: PageContentPermissionChoice) => void;
};

export function PageContentPermissionPrompt({
  hostname,
  onRespond,
}: PageContentPermissionPromptProps) {
  return (
    <div
      aria-label={`Let Vee read ${hostname}?`}
      className="border-brand-200 rounded-lg border bg-white p-3 shadow-sm"
      role="dialog"
    >
      <Text type="body-sm" isHeavy>
        Let Vee read {hostname}?
      </Text>
      <Text type="body-xs" className="text-subtle mt-1">
        Vee can&apos;t see the page you&apos;re looking at right now. Allow Vee
        to read the page so it has the context to help you
      </Text>
      <div className="mt-3 flex flex-wrap justify-end gap-2">
        <Button
          isGhost
          size="small"
          onPress={() => onRespond(PageContentPermissionChoice.DONT_ALLOW)}
        >
          Don&apos;t allow
        </Button>
        <Button
          variant="primary"
          size="small"
          onPress={() => onRespond(PageContentPermissionChoice.ALLOW)}
        >
          Allow
        </Button>
      </div>
    </div>
  );
}
